<template>
  <div v-editable="blok" id="salonImages" class="panorama">
    <img :src="blok.longimage"/>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LongImage.vue